import { FC } from 'react'
import { FlatList } from 'react-native'

import LazyHOC from '@zet/common/components/lazyHoc'
import { LiveCampaignStrip } from '@zet/common/components/otaStrip/liveCampaignStrip'
import { MY_TEAMS_ADVISOR } from '@zet/constants'
import { Stack } from '@zet/design-system/layout'
import { H5, H6 } from '@zet/design-system/typography'
import { APP_NAME } from '@zet/end-points'
import CategoryCard from '@zet/feature-brands/components/categoryCard'
import { i18n } from '@zet/localization'
import { useFetchRef } from '@zet/utils/useFetchRef'

import { useCategories, useGetBanners } from '../../api/brands/hooks'
import { BannerCarousel } from '../../components/bannerCarousel'
import useGetCategories from '../../hooks/useGetCategories'

type CategoriesProps = {
  navigation?: any
  onCategoryPress?: () => void
}

const Categories: FC<CategoriesProps> = (props) => {
  const { data, refetch } = useCategories({ enabled: true })
  const { data: bannersData } = useGetBanners('category')
  useFetchRef(refetch)
  const { CATEGORY_DATA } = useGetCategories({ data })

  return (
    <>
      <Stack className="flex-1 bg-white">
        <H5 className="border-grays-30 text-grays-100 border-b px-3 py-[14]">
          {i18n.t('categories.heading')}
        </H5>
        <LazyHOC isCategory>
          <FlatList
            data={CATEGORY_DATA}
            ListHeaderComponent={
              <>
                {APP_NAME !== MY_TEAMS_ADVISOR && (
                  <>
                    <H6 className="text-grays-70 mt-3">
                      {i18n.t('zetReferral.categoryHeader')}
                    </H6>
                    <BannerCarousel data={bannersData} />
                    <H6 className="text-grays-70 mb-2">
                      {i18n.t('categories.subHeading')}
                    </H6>
                  </>
                )}
              </>
            }
            numColumns={2}
            renderItem={({ item, index }) => (
              <CategoryCard
                id={item.id}
                title={item.title}
                svgIcon={item.svgIcon}
                subtitle={item.subtitle}
                onCategoryPress={props?.onCategoryPress || null}
                keyIndex={index}
              />
            )}
            ListFooterComponent={<Stack className="h-[40]"></Stack>}
            className="px-3"
            keyExtractor={({ id }) => id?.toString()}
          />
        </LazyHOC>
      </Stack>
      <LiveCampaignStrip />
    </>
  )
}

export { Categories }
